import { storage } from "./storage";

export interface IUTM {
	gclid: string | null;
	utmCampaign: string | null;
	utmContent: string | null;
	utmMedia: string | null;
	utmMedium: string | null;
	utmSource: string | null;
	timestamp: number;
}

export function getUtms(): IUTM[] | null {
	if (storage.getItem("traffic_sources2")) {
		return JSON.parse(storage.getItem("traffic_sources2")!);
	}

	return null;
}
